import React from "react";

import PropTypes from "prop-types";

import RbField from "../RbField";
import RbNumberControl from "../RbNumberControl";

function RbNumberField(props) {
  const { fieldName, max, min, required, ...other } = props;

  const validate = React.useCallback(
    (value) => {
      const empty = value === null || value === undefined;

      if (empty && required) {
        return "Required field";
      }

      if (!empty && !Number.isFinite(value)) {
        return "Invalid number";
      }

      if (max !== null && max !== undefined && value > max) {
        return `Value greater than ${max}`;
      }

      if (min !== null && min !== undefined && value < min) {
        return `Value less than ${min}`;
      }

      return undefined;
    },
    [required, max, min]
  );

  return (
    <RbField
      {...other}
      fieldName={fieldName}
      Component={RbNumberControl}
      validate={validate}
      required={required}
      defaultEmptyValue=""
    />
  );
}

RbNumberField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  required: PropTypes.bool,
};

RbNumberField.defaultProps = {
  max: undefined,
  min: undefined,
  required: undefined,
};

export default React.memo(RbNumberField);
